
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.666 4.333h-2v-.667a2 2 0 00-2-2H7.333a2 2 0 00-2 2v.667h-2a2 2 0 00-2 2v6a2 2 0 002 2h9.333a2 2 0 002-2v-6a2 2 0 00-2-2zm-6-.667A.667.667 0 017.333 3h1.333a.667.667 0 01.667.667v.666H6.666v-.667zm6.667 8.667a.666.666 0 01-.667.667H3.333a.667.667 0 01-.667-.667V8.966h2v.7a.667.667 0 101.334 0v-.7h4v.7a.667.667 0 101.333 0v-.7h2v3.367zm0-4.667H2.666V6.333a.667.667 0 01.667-.667h9.333a.666.666 0 01.667.667v1.333z","fill":"#282E3E"}})])
          )
        }
      }
    